// extracted by mini-css-extract-plugin
module.exports = {"page404":"Page404_page404__2sdX7","error404":"Page404_error404__fFAXg"};